import React from 'react';
import T from 'prop-types';
import { Box, Button, Text } from '@acast/decibel';
import List from './list';

const EpisodesList = props => {
  const { episodesTotal, episodes, loadNextBatch, pending, onEpisodeClicked } = props;
  const numTotal = episodesTotal || 0;
  const numLoaded = episodes.length;
  const haveMore = numTotal > numLoaded;

  return (
    <List
      episodes={episodes}
      pending={pending}
      emptyMessage="No episodes."
      onEpisodeClicked={onEpisodeClicked}
      createdColumnHeading="Published"
    >
      {!!numTotal && (
        <Box alignItems="center" justifyContent="space-between" mt={8} mb={4}>
          <Box width="33%" />
          <Button variant="secondary" busy={pending} disabled={!haveMore} onClick={loadNextBatch}>
            Load more
          </Button>
          <Box width="33%" justifyContent="flex-end">
            <Text variant="body2" mb={0}>
              Displaying {numLoaded} of {numTotal} Episodes
            </Text>
          </Box>
        </Box>
      )}
    </List>
  );
};

EpisodesList.propTypes = {
  episodesTotal: T.number,
  pending: T.bool,
  episodes: T.array,
  loadNextBatch: T.func.isRequired,
  onEpisodeClicked: T.func.isRequired,
};

export default EpisodesList;
